import { useQuery } from "react-query";
import { getEmployeeOptions } from "../../../../actions/Employees";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useRecoilValue } from "recoil";

export default function useGetEmployees() {
  const user = useRecoilValue(accountAtom);
  return useQuery(
    "EmployeeOption",
    () => getEmployeeOptions(user.isFranchise, user.isNonFranchise),
    {
      refetchOnWindowFocus: false,
    }
  );
}
